module.exports = __webpack_public_path__ + "static/media/USDT-BNB.6d749afe.svg";